import View from './view';

export default class Presenter {
  constructor(model, onClose) {
    this.model = model;
    this.onClose = onClose;
  }

  onCloseClick() {}

  onAgeValidate(value) {
    this.onClose(value);
  }

  onRedirect() {
    this.model.index = View.Page.error;
  }
}
